module.exports = __webpack_public_path__ + "img/waagner.5df56929.png";